(() => {
  const header = document.querySelector('.header-wrapper');
  if (header) {
    const onScroll = () => {
      header.classList.toggle('is-scrolled', window.scrollY > 12);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  const revealItems = document.querySelectorAll('[data-mcz-reveal]');
  if ('IntersectionObserver' in window && revealItems.length) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('mcz-reveal');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
    );
    revealItems.forEach((el) => io.observe(el));
  }

  document.querySelectorAll('[data-mcz-faq]').forEach((root) => {
    root.querySelectorAll('details').forEach((details) => {
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        root.querySelectorAll('details').forEach((other) => {
          if (other !== details) other.open = false;
        });
      });
    });
  });

  /* Hide GemPages/GemThemes footer duplicates; keep MCZ footer */
  const GP_FOOTER_SELECTORS = [
    '.shopify-section.gps-617144979432670187',
    '.gps-617144979432670187',
    '.shopify-section.gps-616653037166920385',
    '.gps-616653037166920385',
    '[id*="gp_global_section_617144979432670187"]',
    '[id*="gp_section_616653037166920385"]',
  ].join(', ');

  const isMczFooter = (el) =>
    !!(
      el &&
      (el.classList?.contains('section-mcz-footer') ||
        el.classList?.contains('mcz-footer') ||
        el.closest?.('.section-mcz-footer, .mcz-footer, .shopify-section-group-footer-group'))
    );

  const hideEl = (el) => {
    if (!el || isMczFooter(el)) return;
    el.classList.add('mcz-hide-gp-footer');
    el.style.setProperty('display', 'none', 'important');
    el.style.setProperty('visibility', 'hidden', 'important');
    el.setAttribute('aria-hidden', 'true');
  };

  const hideGpFooter = () => {
    document.querySelectorAll(GP_FOOTER_SELECTORS).forEach(hideEl);

    document.querySelectorAll('.shopify-section, section.gps, .gps.gpsil').forEach((section) => {
      if (isMczFooter(section)) return;
      const text = section.textContent || '';
      if (
        /GemThemes/i.test(text) ||
        /Sign up for the latest Ice offers/i.test(text) ||
        (/Our Newsletter/i.test(text) && /Copyright\s*©\s*2022/i.test(text))
      ) {
        hideEl(section);
      }
    });
  };

  hideGpFooter();
  setTimeout(hideGpFooter, 300);
  setTimeout(hideGpFooter, 1000);
  setTimeout(hideGpFooter, 3000);

  if (typeof MutationObserver !== 'undefined') {
    const mo = new MutationObserver(() => hideGpFooter());
    const start = () => {
      if (document.body) {
        mo.observe(document.body, { childList: true, subtree: true });
      }
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start, { once: true });
  }
})();
